import * as React from "react";
const SvgFiRrHippo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hippo_svg__a)">
      <path
        fill="#062147"
        d="M15.25 14h4.5C22.093 14 24 12.085 24 9.731c0-1.258-.552-2.43-1.5-3.233v-.499a4.97 4.97 0 0 0-1.003-3h.003a1.5 1.5 0 1 0-1.5-1.5v.171a4.97 4.97 0 0 0-2.5-.671c-.91 0-1.764.245-2.5.671v-.171a1.5 1.5 0 1 0-1.5 1.5h.003a5 5 0 0 0-.902 2H9C4.589 5 1 8.589 1 13c0 .833.13 1.65.379 2.425l-1.236 2.06a1 1 0 0 0 1.715 1.03l.574-.956A8 8 0 0 0 4 19.24v1.761c0 1.654 1.346 3 3 3s3-1.346 3-3h3c0 1.654 1.346 3 3 3s3-1.346 3-3v-1.76a8 8 0 0 0 1.56-1.667 1 1 0 1 0-1.638-1.147 6 6 0 0 1-1.495 1.493 1 1 0 0 0-.428.82V21c0 .551-.45 1-1 1-.551 0-1-.449-1-1v-1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1c0 .551-.45 1-1 1-.551 0-1-.449-1-1v-2.25c0-.647-.423-.826-.427-.829A6.03 6.03 0 0 1 3.49 15.37a1 1 0 0 0-.17-.441A6 6 0 0 1 3 13c0-3.309 2.69-6 6-6h2.999a4.22 4.22 0 0 0-1 2.731C11 12.085 12.908 14 15.25 14M17.5 3c1.654 0 3 1.346 3 3v1a1 1 0 0 0 .459.841 2.24 2.24 0 0 1 1.04 1.89 2.27 2.27 0 0 1-1 1.885v-.617a1 1 0 0 0-2 0v1h-3v-1a1 1 0 0 0-2 0v.617a2.27 2.27 0 0 1-1-1.885 2.24 2.24 0 0 1 1.042-1.89A1 1 0 0 0 14.5 7V6c0-1.654 1.346-3 3-3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hippo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHippo;
